import type { HeroCta } from "@/components/landing/types";
import { faChevronRight, faCommentDots } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@/components/ui/Icon";
import { Link } from "@/i18n/navigation";

interface HeroButtonsProps {
	primary: HeroCta;
	secondary?: HeroCta | null;
}

function HeroButtons(prop: HeroButtonsProps) {
	const { primary, secondary } = prop;
	return (
		<div className="mt-10 flex flex-wrap gap-3">
			<Link href={primary.href} className="btn btn-primary gap-2 px-6 py-3 text-base">
				{primary.label}
				<Icon icon={faChevronRight} className="h-4 w-4" />
			</Link>
			{secondary?.label && (
				<a href={secondary.href} className="btn btn-outline gap-2 px-6 py-3 text-base">
					<Icon icon={faCommentDots} className="h-4 w-4" />
					{secondary.label}
				</a>
			)}
		</div>
	);
}

export default HeroButtons;
